import {
  Component,
  ElementRef,
  Inject,
  inject,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { filter, map, Observable, startWith, switchMap } from 'rxjs';
import { Tenants } from '../../interface/tenants';
import { Loops } from '../../interface/loops';
import { MeterService } from '@feature/meter';
import { CreateNewMeter } from '../../interface/meter';
import { DialogService, SessionStore, ToastService } from '@core';
import { Panels } from '../../interface/panels';
import { Tags } from '../../interface/tags';
import { MeterFormKeys } from '../../data-access/meter.type';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LocationTierKey } from '@contracts';
import { D } from '@angular/cdk/keycodes';

@Component({
  selector: 'core-create-meter',
  templateUrl: './create-meter.component.html',
  styleUrl: './create-meter.component.scss',
})
export class CreateMeterModalComponent implements OnInit {
  meterName: string = '';
  @ViewChildren('inputRef') inputs!: QueryList<ElementRef>;
  descriptionValue: string = '';
  startTime: string = '';
  separatorKeysCodes: number[] = [13, 188];
  converterCode: string = '';
  private sessionStore = inject(SessionStore);
  module_list = ['RMS', 'EMS'];
  private initialFormValue: any;
  tagCtrl = new FormControl('');
  filteredTags!: Observable<Tags[]>;
  meter_type_list = ['energy', 'water'];
  locationList: Record<LocationTierKey, string[]> = {
    location_tier_1: [],
    location_tier_2: [],
    location_tier_3: [],
    location_tier_4: [],
    location_tier_5: [],
  };

  filteredLocationList: Record<LocationTierKey, string[]> = {
    location_tier_1: [],
    location_tier_2: [],
    location_tier_3: [],
    location_tier_4: [],
    location_tier_5: [],
  };
  formMeter = new FormGroup({
    meter_id: new FormControl(null, Validators.required),
    sub_meter_id: new FormControl(null),
    name: new FormControl('', Validators.required),
    shop_name: new FormControl(''),
    sensor_type: new FormControl('energy'),
    panel: new FormControl(null),
    loop_name: new FormControl(null, Validators.required),
    serial_number: new FormControl(null),
    module: new FormControl(this.sessionStore.getModule()),
    description: new FormControl(''),
    brand: new FormControl(''),
    model: new FormControl(null),
    unit_id: new FormControl(''),
    group_id: new FormControl(''),
    location_id: new FormControl(null),
    zone_id: new FormControl(''),
    location: new FormControl(''),
    building: new FormControl(''),
    floor: new FormControl(''),
    type: new FormControl('energy'),
    loop_id: new FormControl(null),
    panel_id: new FormControl(null),
    tenant_name: new FormControl(null),
    tags: new FormControl<any[]>([]),

    location_tier_1: new FormControl<string | null>(null, Validators.required),
    location_tier_2: new FormControl<string | null>(null, Validators.required),
    location_tier_3: new FormControl<string | null>(null, Validators.required),
    location_tier_4: new FormControl<string | null>(null),
    location_tier_5: new FormControl<string | null>(null),
  });

  get test_sync_button_check(): boolean {
    try {
      let formMeter = this.formMeter.value;
      let get_bran_selected = this.get_bran_selected;
      if (
        formMeter.meter_id &&
        get_bran_selected.model &&
        get_bran_selected.name
      ) {
        return true;
      }
    } catch (error) {}
    return false;
  }

  unit_id_validator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.find_unit_id(control.value)) {
        return null;
      } else {
        return { error: 'Not Unit ID' };
      }
    };
  }

  filtere = '';

  filteredOptionsTenant: Observable<Tenants[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateMeterModalComponent>,
    private meterService: MeterService,
    public dialog: DialogService,
    public route: ActivatedRoute,
    private router: Router,
    private toast: ToastService,
  ) {
    if (!this.isPanelTier4Enabled()) this.formMeter.get('panel')?.disable();
    else this.formMeter.get('panel')?.enable();
    this.filteredOptionsTenant =
      this.formMeter.controls.tenant_name.valueChanges.pipe(
        startWith(''),
        map((value) => {
          return this.filterTenant(value || '');
        }),
      );
    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(''),
      map((value: string | null) => {
        const filterValue = value || '';
        return this._filterTags(filterValue);
      }),
    );
  }

  isLocationTier4Enabled(): boolean {
    const value = this.sessionStore.getDictionariesValidate()?.location_tier_4;
    return value !== null && value !== undefined && value !== false;
  }

  isPanelTier4Enabled(): boolean {
    const value = this.sessionStore.getDictionariesValidate()?.panel_tier_5;
    return value !== null && value !== undefined && value !== false;
  }

  private _filterTags(value: string): Tags[] {
    const filterValue = value.toLowerCase();
    const selectedTags = this.formMeter.get('tags')?.value || [];

    return this.tags_list.filter(
      (tag) =>
        tag.name.toLowerCase().includes(filterValue) &&
        !selectedTags.includes(tag.id),
    );
  }

  private _filter_unit_data(value: string, options_data: any[]): string[] {
    const filterValue = value.toLowerCase();
    return options_data.filter((option) =>
      option.room.toLowerCase().includes(filterValue),
    );
  }

  ngOnInit(): void {
    this.callapi();
    this.initialFormValue = this.formMeter.getRawValue();
    this.formMeter.get('model')?.disable();
    this.formMeter.get('location_tier_2')?.disable();
    this.formMeter.get('location_tier_3')?.disable();
    this.formMeter.get('location_tier_4')?.disable();
    this.formMeter.get('location_tier_5')?.disable();

    this.formMeter.get('brand')?.valueChanges.subscribe((value) => {
      const modelCtrl = this.formMeter.get('model');

      if (!value) {
        modelCtrl?.disable();
        modelCtrl?.reset();
      } else {
        modelCtrl?.enable();
      }
    });
    if (
      !this.isLocationTier4Enabled() ||
      !this.formMeter.get('location_tier_3')?.value
    ) {
      this.formMeter.get('location_tier_4')?.disable();
    } else {
      this.formMeter.get('location_tier_4')?.enable();
    }

    this.formMeter.get('location_tier_1')?.valueChanges.subscribe((v) => {
      if (!v) {
        this.formMeter.get('location_tier_2')?.disable();
        this.formMeter.get('location_tier_3')?.disable();
        this.formMeter.patchValue(
          {
            location_tier_2: null,
            location_tier_3: null,
            location_tier_4: null,
          },
          { emitEvent: false },
        );
        return;
      }

      this.getTier2Options(v);
      this.formMeter.get('location_tier_2')?.enable();
    });

    this.formMeter.get('location_tier_2')?.valueChanges.subscribe((v) => {
      this.getTier3Options(v ?? undefined);
      this.locationList.location_tier_4 = [];
      if (v) {
        this.formMeter.get('location_tier_3')?.enable();
      } else {
        this.formMeter.get('location_tier_3')?.disable();
      }
      this.formMeter.patchValue(
        {
          location_tier_3: null,
          location_tier_4: null,
        },
        { emitEvent: false },
      );
    });

    this.formMeter.get('location_tier_3')?.valueChanges.subscribe((v) => {
      this.getTier4Options(v ?? undefined);
      if (v) {
        this.formMeter.get('location_tier_4')?.enable();
      } else {
        this.formMeter.get('location_tier_4')?.disable();
      }
      this.formMeter.patchValue(
        {
          location_tier_4: null,
          location_tier_5: null,
        },
        { emitEvent: false },
      );
    });

    this.formMeter.get('location_tier_4')?.valueChanges.subscribe((v) => {
      const tier3Value = this.formMeter.get('location_tier_3')?.value;
      this.getTier5Options(tier3Value ?? undefined, v ?? undefined);
      if (v) {
        this.formMeter.get('location_tier_5')?.enable();
      } else {
        this.formMeter.get('location_tier_5')?.disable();
      }
      this.formMeter.patchValue(
        {
          location_tier_5: null,
        },
        { emitEvent: false },
      );
    });
  }

  async callapi() {
    // this.loadPublicUnit()
    // this.loadGroupList();
    this.loadBrandList();
    this.loadPanels();
    this.loadLocations();
    this.loadTags();
    this.loadTenantsMeter();
    this.loadLoops();
  }
  addTagFromAutocomplete(event: any) {
    if (
      !this.tags_list.some(
        (t) => t.name.toLowerCase() === (event.value || '').toLowerCase(),
      )
    ) {
      this.tagCtrl.setValue('');
      return;
    }
  }

  selectedTag(event: MatAutocompleteSelectedEvent) {
    const selectedTag = this.tags_list.find(
      (t) => t.name === event.option.value,
    );
    if (selectedTag) {
      const current = this.formMeter.value.tags || [];
      this.formMeter.patchValue({ tags: [...current, selectedTag.id] });
      this.tagCtrl.setValue('');
    }
  }

  get get_location() {
    try {
      let data = this.unit_list;
      return [
        ...new Map(data.map((item) => [item.location_id, item])).values(),
      ];
    } catch (error) {}
    return [];
  }

  get get_building() {
    try {
      let data = this.unit_list.filter(
        (v) => v.location_id == this.formMeter.value.location_id,
      );
      return [
        ...new Map(data.map((item) => [item.building_id, item])).values(),
      ];
    } catch (error) {}
    return [];
  }

  get get_zone() {
    try {
      let data = this.unit_list.filter(
        (v) => v.location_id == this.formMeter.value.location_id,
      );
      return [...new Map(data.map((item) => [item.floor_id, item])).values()];
    } catch (error) {}
    return [];
  }

  get get_unit_list() {
    try {
      let data = this.unit_list.filter(
        (v) => v.location_id == this.formMeter.value.location_id,
      );
      return data;
    } catch (error) {}
    return [];
  }

  get get_unit_id() {
    try {
      let data = this.unit_list.filter(
        (v) => v.location_id == this.formMeter.value.location_id,
      );
      return data[0].unit_id;
    } catch (error) {}
    return '';
  }

  find_unit_id(value: string) {
    try {
      let data = this.unit_list.filter(
        (v) =>
          v.location_id == this.formMeter.value.location_id && v.room == value,
      );
      return data[0].unit_id;
    } catch (error) {}
    return '';
  }

  get get_bran_selected(): {
    name: string;
    model: string;
  } {
    try {
      let formMeter = this.formMeter.value;
      let data = this.brand_list.filter((v) => {
        return formMeter.brand == v.id;
      });
      if (data[0]) {
        return data[0];
      } else {
        return { name: '', model: '' };
      }
    } catch (error) {
      return { name: '', model: '' };
    }
  }

  sync_data?: {
    online_status: boolean;
    data: string;
    message: string;
  } | null;

  test_sync_click() {
    this.sync_data = null;
    let formMeter = this.formMeter.value;
    let get_bran_selected = this.get_bran_selected;
    this.meterTestSync({
      // conv_ip: formMeter.conv_ip || '',
      meter_id: formMeter.meter_id || '',
      sub_meter_id: formMeter.sub_meter_id || '',
      // port: formMeter.port || '',
      brand: get_bran_selected?.name || '',
      model: get_bran_selected?.model || '',
    });
  }

  meterTestSync(req: {
    // conv_ip: string;
    meter_id: string;
    sub_meter_id: string;
    // port: string;
    brand: string;
    model: string;
  }) {
    this.dialog.withLoading(this.meterService.meterTestSync(req)).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            this.sync_data = response.meta.response_data;
          } catch (error) {
            console.error(error);
          }
        } else {
          this.toast.error('เกิดข้อผิดพลาด');
        }
      },
      error: (e) => {
        console.error(e);
        this.toast.error('เกิดข้อผิดพลาด');
      },
    });
  }

  unit_list: any[] = [];

  loadPublicUnit() {
    this.dialog.withLoading(this.meterService.getPublicUnit()).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            this.unit_list = response.meta.response_data;
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  group_list: any[] = [];

  get get_group() {
    let data = this.group_list.map((v) => v.name);
    return data;
  }

  loadGroupList() {
    this.dialog.withLoading(this.meterService.getGroups()).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          this.group_list = response.meta.response_data.groups;
        } else {
          alert('Occurred');
        }
      },
      error: (e) => console.error(e),
    });
  }

  brand_list: any[] = [];

  get get_brand() {
    try {
      let data = Array.from(new Set(this.brand_list.map((v) => v.name).sort()));
      return data;
    } catch (error) {}
    return [];
  }

  get get_model() {
    try {
      let data = this.brand_list
        .filter((v) => v.name == this.formMeter.value.brand)
        .sort((a, b) => {
          if (a.model < b.model) return -1;
          if (a.model > b.model) return 1;
          return 0;
        });
      return data;
    } catch (error) {}
    return [];
  }

  loadBrandList() {
    this.dialog.withLoading(this.meterService.getBrand('public')).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          this.brand_list = response.meta.response_data;
        } else {
          this.toast.error('');
        }
      },
      error: (e) => console.error(e),
    });
  }

  panels_list: Panels[] = [];
  loadPanels() {
    this.dialog.withLoading(this.meterService.getPanels('public')).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            let data = response.meta.response_data;
            this.panels_list = data;
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }
  allLocations: any[] = [];

  private getSelectedLocationId(): number | null {
    const {
      location_tier_1,
      location_tier_2,
      location_tier_3,
      location_tier_4,
      location_tier_5,
    } = this.formMeter.value;

    const found = this.allLocations.find(
      (loc) =>
        this.normalize(loc.location_tier_1) ===
          this.normalize(location_tier_1) &&
        this.normalize(loc.location_tier_2) ===
          this.normalize(location_tier_2) &&
        this.normalize(loc.location_tier_3) ===
          this.normalize(location_tier_3) &&
        this.normalize(loc.location_tier_4) ===
          this.normalize(location_tier_4) &&
        this.normalize(loc.location_tier_5) === this.normalize(location_tier_5),
    );

    return found?.id ?? null;
  }

  loadLocations() {
    this.dialog
      .withLoading(this.meterService.getLocations('detail'))
      .subscribe({
        next: (response) => {
          if (response.meta.response_code === 20000) {
            this.allLocations = response.meta.response_data;

            this.buildLocationOptions();

            this.getTier2Options();
            this.getTier3Options();
            this.getTier4Options();
            this.getTier5Options();
          }
        },
        error: (e) => console.error(e),
      });
  }

  buildLocationOptions() {
    const data = this.allLocations;

    this.locationList.location_tier_1 = [
      ...new Set(data.map((d) => d.location_tier_1).filter(Boolean)),
    ];
  }
  tags_list: Tags[] = [];
  loadTags() {
    this.dialog.withLoading(this.meterService.getTags('public')).subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            let data = response.meta.response_data;
            this.tags_list = data;
            this.tagCtrl.setValue(this.tagCtrl.value || '');
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }
  getTier2Options(overrideValue?: string) {
    const selected = overrideValue ?? this.formMeter.value.location_tier_1;

    this.locationList.location_tier_2 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_1 === selected)
          .map((d) => d.location_tier_2)
          .filter(Boolean),
      ),
    ];
  }

  getTier3Options(overrideValue?: string) {
    const selected = overrideValue ?? this.formMeter.value.location_tier_2;

    if (!selected) {
      this.locationList.location_tier_3 = [];
      return;
    }

    this.locationList.location_tier_3 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_2 === selected)
          .map((d) => d.location_tier_3)
          .filter(Boolean),
      ),
    ];
  }
  private normalize(value: any) {
    return value ?? null;
  }

  getTier4Options(overrideValue?: string) {
    const selected = overrideValue ?? this.formMeter.value.location_tier_3;

    this.locationList.location_tier_4 = [
      ...new Set(
        this.allLocations
          .filter((d) => d.location_tier_3 === selected)
          .map((d) => d.location_tier_4)
          .filter(Boolean),
      ),
    ];
  }

  getTier5Options(overrideValueTier3?: string, overrideValueTier4?: string) {
    const selectedTier3 =
      overrideValueTier3 ?? this.formMeter.value.location_tier_3;
    const selectedTier4 = overrideValueTier4 ?? this.formMeter.value.location_tier_4;

    this.locationList.location_tier_5 = [
      ...new Set(
        this.allLocations
          .filter(
            (d) =>
              d.location_tier_4 === selectedTier4 &&
              selectedTier3 === d.location_tier_3,
          )
          .map((d) => d.location_tier_5)
          .filter(Boolean),
      ),
    ];
  }

  tenants_list: Tenants[] = [];
  get tenants_id_selected() {
    try {
      let tenant_name = this.formMeter.value.tenant_name;
      let tenants_list = this.tenants_list;
      let tenants_select = tenants_list.filter(
        (v) => <string | null>v.name == tenant_name,
      );
      if (tenants_select.length == 1) {
        return tenants_select[0].id;
      }
    } catch (error) {}
    return null;
  }

  loadTenantsMeter() {
    this.meterService.getTenants('public').subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            this.tenants_list = response.meta.response_data;
            this.formMeter.patchValue({
              tenant_name: null,
            });
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  loops_list: Loops[] = [];
  loadLoops() {
    this.meterService.getLoops('list').subscribe({
      next: (response) => {
        if (response.meta.response_code == 20000) {
          try {
            let data = response.meta.response_data;
            this.loops_list = data;
          } catch (error) {
            console.error(error);
          }
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }
  icon = 'assets/shared/icons/meter.svg';
  cancel() {
    this.dialogRef.close();
  }

  createMeter() {
    this.dialog
      .confirm({
        icon: {
          type: 'img',
          src: this.icon,
        },
        title: 'view_value.create_meter',
        message: ['view_value.confirm_create_meter'],
      })
      .pipe(
        filter(Boolean),
        switchMap(() => {
          let formGroup = this.formMeter.value;
          let paload: CreateNewMeter = {
            name: formGroup.name,
            shop_name: formGroup.shop_name,
            meter_id: formGroup.meter_id,
            sub_meter_id: formGroup.sub_meter_id,
            type: formGroup.sensor_type,
            module: formGroup.module,
            sensor_type: formGroup.sensor_type,
            serial_number: formGroup.serial_number,
            description: formGroup.description,
            loop_id: formGroup.loop_name,
            panel_id: formGroup.panel,
            brand_id: formGroup.model,
            location_id: this.getSelectedLocationId(),
            tenant_id: this.tenants_id_selected,
            tag_id: formGroup.tags || [],
            install_date: null,
          };
          return this.meterService.createMeter(paload ? paload : '');
        }),
      )
      .subscribe({
        next: (responsedata) => {
          if (responsedata.meta.response_code == 20000) {
            this.dialogRef.close('updated');
            this.toast.success('บันทึกการสร้างข้อมูลสำเร็จ');
          } else this.toast.error('สร้างข้อมูลไม่สำเร็จ');
        },
        error: (e) => {},
        complete: () => {},
      });
  }

  displayTenant(tenant: string): string {
    return tenant;
  }

  undoField(field: MeterFormKeys) {
    const control = this.formMeter.get(field);
    if (!control) return;
    const originalValue = this.initialFormValue[field];

    const value =
      Array.isArray(originalValue) || typeof originalValue === 'object'
        ? structuredClone(originalValue)
        : originalValue;

    control.setValue(value);
    control.markAsPristine();
    control.markAsUntouched();
    control.updateValueAndValidity();
  }

  resetAll() {
    if (!this.initialFormValue) return;
    this.formMeter.reset(structuredClone(this.initialFormValue));

    this.tagCtrl.setValue('');
  }

  private filterTenant(data: string): Tenants[] {
    const filterValue = data.toLowerCase();
    return this.tenants_list.filter((option) =>
      option.name.toLowerCase().includes(filterValue),
    );
  }
  private nomalize(value: any): any {
    if (value === null || value === undefined || value === '') return null;

    if (typeof value === 'string') return value.trim();

    return value;
  }

  getDiff() {
    if (!this.initialFormValue) return [];

    const current = this.formMeter.getRawValue();

    return (Object.keys(this.initialFormValue) as MeterFormKeys[])
      .filter((key) => !this.isEqual(this.initialFormValue[key], current[key]))
      .map((key) => ({
        field: key,
        old: this.initialFormValue[key],
        new: current[key],
      }));
  }

  private isEqual(a: any, b: any): boolean {
    a = this.nomalize(a);
    b = this.nomalize(b);

    if (a === b) return true;

    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      return a.every((v, i) => this.isEqual(v, b[i]));
    }

    if (typeof a === 'object' && typeof b === 'object') {
      if (!a || !b) return false;

      const keysA = Object.keys(a);
      const keysB = Object.keys(b);

      if (keysA.length !== keysB.length) return false;

      return keysA.every((k) => this.isEqual(a[k], b[k]));
    }

    return false;
  }

  isEdited(field: MeterFormKeys): boolean {
    return this.getDiff().some((d) => d.field === field);
  }

  removeTag(tagId: any) {
    const current = this.formMeter.value.tags || [];
    this.formMeter.patchValue({
      tags: current.filter((t: any) => t !== tagId),
    });
    this.tagCtrl.setValue(this.tagCtrl.value || '');
  }

  getTagName(id: any) {
    const found = this.tags_list.find((t) => t.id === id);
    return found?.name || id;
  }
}
